/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import React, { useState } from 'react';

import { Authenticated, FallbackComponent, Unuthenticated, useAuth, useIndexName, useMount } from 'nmqf-common-ui';

const PublicAuthenticate = () => {
  const auth = useAuth();
  const [isLoaded, setIsLoaded] = useState(false);
  const indexName = useIndexName();

  useMount(() => {
    const authenticate = async () => {
      await auth.authenticate({ indexName });
      setIsLoaded(true);
    };
    authenticate();
  });

  return <FallbackComponent requesting={!isLoaded} error={auth.getError()} />;
};

export const Authenticate: React.FC = (props) => {
  return (
    <>
      <Unuthenticated>
        <PublicAuthenticate />
      </Unuthenticated>
      <Authenticated>{props.children}</Authenticated>
    </>
  );
};
